import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-flok-badge',
    templateUrl: 'flok-badge.html'
})
export class FlokBadgeComponent {
    @Input() classNames: string | undefined
}
